// extracted by mini-css-extract-plugin
module.exports = {"body":"ResultCheckBox_body__1C0Wt"};